module.exports = __webpack_public_path__ + "img/preview.a83db328.png";